import store from '@Store';

import {
  poorNetworkConnectionToastMessage as poorNetworkConnectionToastMessageAction,
} from '../PoorNetToastMessage/PoorNetToastMessageActions';
import {
  websocketsAreUnstableToastMessage as websocketsAreUnstableToastMessageAction,
  newToastMessage as newToastMessageAction
} from './ToastMessagesActions';

export function poorNetworkConnectionToastMessage () {
  store.dispatch(poorNetworkConnectionToastMessageAction());
}

export function websocketsAreUnstableToastMessage () {
  store.dispatch(websocketsAreUnstableToastMessageAction());
}

export function newToastMessage(...args) {
  store.dispatch(newToastMessageAction(...args));
}
